// Слот навигации проекта в глобальном Topbar. Раздел проекта (Поиск/Генерация)
// живёт на одной линии с лого и email. ProjectView регистрирует активную вкладку
// и обработчик через контекст; Topbar рисует вкладки по центру. Через контекст
// (а не чтение URL в Topbar), чтобы корректно работал и peek-кейс открытого поста.

import { createContext, useContext, useState, type ReactNode } from 'react'

export type ProjectTab = 'search' | 'generation'

export interface ProjectNavState {
  activeTab: ProjectTab
  onSelect: (tab: ProjectTab) => void
}

interface ProjectNavContextValue {
  nav: ProjectNavState | null
  setNav: (nav: ProjectNavState | null) => void
}

const ProjectNavContext = createContext<ProjectNavContextValue>({ nav: null, setNav: () => {} })

export function ProjectNavProvider({ children }: { children: ReactNode }) {
  const [nav, setNav] = useState<ProjectNavState | null>(null)
  return <ProjectNavContext.Provider value={{ nav, setNav }}>{children}</ProjectNavContext.Provider>
}

export function useProjectNav(): ProjectNavContextValue {
  return useContext(ProjectNavContext)
}

// Сами вкладки раздела — рендерятся в Topbar, когда открыт проект.
export function ProjectTabsBar({ activeTab, onSelect }: ProjectNavState) {
  return (
    <nav className="project-tabs-bar" role="tablist" aria-label="Разделы проекта">
      <button
        type="button"
        role="tab"
        aria-selected={activeTab === 'search'}
        className={['project-tab', activeTab === 'search' ? 'active' : ''].filter(Boolean).join(' ')}
        onClick={() => onSelect('search')}
      >
        Поиск
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={activeTab === 'generation'}
        className={['project-tab', activeTab === 'generation' ? 'active' : ''].filter(Boolean).join(' ')}
        onClick={() => onSelect('generation')}
      >
        Генерация
      </button>
      <button type="button" className="project-tab disabled" disabled>
        Аналитика <span>Скоро</span>
      </button>
    </nav>
  )
}
